import CreateProjectsBtn from './create_projects_btn'
import ElementsSelectorApp from './elements_selector_app'
import LocationsSelectorApp from './locations_selector_app'
import NextBtn from './next_btn'
import PreparationDates from './preparation_dates'
import Summary from './summary'
import UpdateTableBtn from './update_table_btn'
import WaitProcessing from './wait_processing'

export default {
  CreateProjectsBtn,
  ElementsSelectorApp,
  LocationsSelectorApp,
  NextBtn,
  PreparationDates,
  Summary,
  UpdateTableBtn,
  WaitProcessing
}
